import {
    Box,
    Button,
    Stack,
    Step,
    StepLabel,
    Stepper,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHooks";
import { useAnalytics } from "../../../hooks/useAnalytics";
import { setShowErrors } from "../../../slices/CustomerDataSlice";
import {
    useCustomerDataContext,
    ViewMode,
} from "../context/CustomerDataContext";
import AppStep from "./AppStep";

export default function JourneySteps() {
    const [activeStep, setActiveStep] = useState(0);
    const MaxStep = 3;
    const { track } = useAnalytics();

    useEffect(() => {
        const step = stepQuestions.find((s) => s.step === activeStep);
        if (step) {
            track("step-tracker", {
                step: step.step,
                title: step.title,
            });
        }
    }, [activeStep, track]);

    const dispatch = useAppDispatch();
    const { stepQuestions } = useAppSelector(
        (state) => state.customerDataSlice
    );
    const stepValidation = (step: number) => {
        const s = stepQuestions.find((s) => s.step === step);
        dispatch(setShowErrors({ step }));

        return s?.questions.length === s?.answers.length;
    };

    const theme = useTheme();
    const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

    const { setViewMode } = useCustomerDataContext();

    const handleNextStep = () => {
        if (stepValidation(activeStep)) {
            if (activeStep === MaxStep) {
                setViewMode(ViewMode.Result);
            }
            setActiveStep((prevActiveStep) =>
                Math.min(prevActiveStep + 1, MaxStep)
            );
        }
    };

    const handlePreviousStep = () => {
        setActiveStep((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
    };

    const steps = stepQuestions.map((s) => s.label);

    return (
        <Stack spacing={2}>
            <Typography fontSize="large">
                فروش یک فرآیند رفت و برگشتیه. یه سری پیش‌نیازها داره، یه روندی
                رو طی می‌کنه و به نتیجه می‌رسه. در ادامه و با همدیگه این فرآیند
                رو به طور خاص برای کار شما شخصی‌سازی و تدوین می‌کنیم.
            </Typography>

            <Stepper
                activeStep={activeStep}
                orientation={isSmall ? "vertical" : "horizontal"}
            >
                {steps.map((step, index) => (
                    <Step key={index}>
                        <StepLabel>{step}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <AppStep step={activeStep} />

            <Stack
                direction="row"
                justifyContent={"space-between"}
            >
                <Box>
                    {activeStep !== 0 && (
                        <Button
                            variant="contained"
                            onClick={handlePreviousStep}
                        >
                            قبلی
                        </Button>
                    )}
                </Box>

                <Box>
                    <Button
                        id={`step-${activeStep + 1}`}
                        variant="contained"
                        onClick={handleNextStep}
                    >
                        بعدی
                    </Button>
                </Box>
            </Stack>
        </Stack>
    );
}
